module.exports = __webpack_public_path__ + "img/user-avatar.154606d9.jpg";